import React from 'react';
import './arrayHeader.scss'

interface IArrayHeader{
    title: string
    goBack: ()=>void
}

export const ArrayHeader = (props:IArrayHeader)=>{
    return <div className='array-header'>
        <img onClick={props.goBack} className='back-button' src="./assets/img/icons/back_icn.svg" />
        <h5>{props.title}</h5>
    </div>
}